
export default {
  methods: {
    /**
     * 轉民國年(需搭配vuetify datepicker v1.5 )
     */
    formatDate (date) {
      if (!date) return null
      const [year, month, day] = date.split('-')
      return `${year}-${month}-${day}`
    },
    headerFormatDates: val => {
      const year = parseInt(val.split('-')[0])
      const month = parseInt(val.split('-')[1])
      return isNaN(month) ? `${year}年` : `${year}年 ${month}月`
    }
  }
}
